module.exports = [{
      plugin: require('/codebuild/output/src431342473/src/vad/node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-115771509-2"},
    }]
